export function calculateOrderShipping(rows, rules, country, method) {
  if (method === 'pickup' || method.startsWith('pickup:')) {
    const pickup = rules['shipping.pickup'];
    if (!pickup?.enabled || pickup.price == null || !Number.isFinite(Number(pickup.price)) || Number(pickup.price) < 0) throw new Error('unavailable');
    return {price: Number(pickup.price), weight: null};
  }
  const rule = rules[`shipping.${String(country).toLowerCase()}`];
  if (!rule || rule.calculation !== 'weight') throw new Error('unavailable');
  let weight = 0;
  if (!rows.length) throw new Error('missing_weight');
  rows.forEach(row => {
    if (row.weight == null || !Number.isFinite(Number(row.weight)) || Number(row.weight) < 0 || !Number.isFinite(Number(row.quantity)) || Number(row.quantity) < 0) throw new Error('missing_weight');
    weight += Number(row.weight) * Number(row.quantity);
  });
  if (!Number.isFinite(weight)) throw new Error('missing_weight');
  let price = Number(rule.default);
  if (!Number.isFinite(price) || price < 0) throw new Error('unavailable');
  [...(rule.steps || [])].sort((a, b) => Number(a.value) - Number(b.value)).forEach(step => {
    if (Number(step.value) < Math.ceil(weight)) price = Number(step.price);
  });
  if (!Number.isFinite(price) || price < 0) throw new Error('unavailable');
  return {price, weight};
}
